import { useQuery } from 'react-query'
import { LicenseAPI } from '../../apis'

type propsType = {
  orgId: number | null
}

const useOrganizationLicenses = (props: propsType) => {
  const { data, isLoading, isError, error } = useQuery(
    ['organization', 'license', 'list', props.orgId],
    () => LicenseAPI.getAllLicenses(props?.orgId, {}),
    {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  )

  return { count: data?.length || 0, data, isLoading, isError, error }
}

export default useOrganizationLicenses
